import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { StockUnits, StockUnit, CreateStockUnit, ScanToStock } from "./pages";

export const StockUnitsRouter = [
  <Route
    path="/stock-units"
    element={
      <ProtectedRoute roles={["Any"]}>
        <StockUnits />
      </ProtectedRoute>
    }
  />,

  <Route path="/stock-unit">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateStockUnit />
        </ProtectedRoute>
      }
    />
    <Route
      path="scan"
      element={
        <ProtectedRoute roles={["Any"]}>
          <ScanToStock />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <StockUnit />
        </ProtectedRoute>
      }
    />
  </Route>,
];
